import * as React from "react";
import { Button } from "@mui/material";
import {
  primaryButtonSx,
  outlineButtonSx,
  marketingColors,
  marketingFonts,
} from "../tickitMarketingTheme";

const variants = {
  primary: primaryButtonSx,
  outline: outlineButtonSx,
  ghost: {
    color: marketingColors.p700,
    fontFamily: marketingFonts.body,
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "10px",
    "&:hover": { bgcolor: marketingColors.p50 },
  },
  danger: {
    bgcolor: "#FEE2E2",
    color: "#DC2626",
    fontFamily: marketingFonts.body,
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "10px",
    boxShadow: "none",
    "&:hover": { bgcolor: "#DC2626", color: "#fff" },
  },
};

export default function MarketingButton({
  variant = "primary",
  size = "medium",
  children,
  sx = {},
  ...rest
}) {
  const sizeSx = size === "small" ? { py: 0.75, px: 2, fontSize: "0.8125rem" } : {};
  const muiVariant = variant === "primary" || variant === "danger" ? "contained" : variant === "outline" ? "outlined" : "text";

  return (
    <Button variant={muiVariant} sx={{ ...variants[variant], ...sizeSx, ...sx }} {...rest}>
      {children}
    </Button>
  );
}
